import React from "react";
import ReactDOM from "react-dom/client";
import initSentry, { Sentry } from "./sentryClient";
import { send as frontendLog } from "./utils/frontendLogger";
import { isExpectedMediaPlaybackInterruption } from "./utils/mediaPlayback";
import { HashRouter } from "react-router";
import "./App.css";
import App from "./App";
import { ToastProvider } from "./components/ToastProvider";
import { AuthProvider } from "./contexts/AuthContext";
import { publicEntryRoute } from "./utils/publicEntryRoute";

if (typeof window !== "undefined") {
  const target = publicEntryRoute(window.location);
  if (target) window.history.replaceState(null, "", target);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
initSentry();
root.render(
  <HashRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    {Sentry ? (
      <Sentry.ErrorBoundary fallback={<div>An error occurred</div>}>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </Sentry.ErrorBoundary>
    ) : (
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    )}
  </HashRouter>
);

// Global error handlers: forward to backend logging endpoint when enabled
window.addEventListener("error", event => {
  try {
    if (isExpectedMediaPlaybackInterruption(event.error || event.message)) {
      event.preventDefault();
      return;
    }
    frontendLog("error", event.message || "window error", {
      filename: event.filename,
      lineno: event.lineno,
    });
  } catch (e) {}
});
window.addEventListener("unhandledrejection", event => {
  try {
    const reason = event.reason || {};
    if (isExpectedMediaPlaybackInterruption(reason)) {
      event.preventDefault();
      return;
    }
    frontendLog("error", reason.message || "unhandledrejection", { reason });
  } catch (e) {}
});
